import {
  ArrowDoorIn,
  Bath,
  Cake,
  CardPos,
  Crown,
  Cup,
  CupPaper,
  Droplet,
  ForkKnife,
  LockKeyhole,
  MusicNote,
  Qr,
  Roadmap,
  Rocket,
  Shop,
  ShoppingBag,
  Snowflake,
  Sofa,
  Star,
  Stethoscope,
  TicketStar,
  Truck,
} from 'reicon-react'

export const markerIcons = {
  'Tecate Original': MusicNote,
  'Tecate Light': MusicNote,
  'Sorpresa Viva': MusicNote,
  'Acústico Hey!': MusicNote,
  'Club Social Kia': MusicNote,
  'Oasis Bacardí': MusicNote,
  'Villa Maravilla': MusicNote,
  "Hot Nuts Pilo's": MusicNote,
  'Fusión Telcel': MusicNote,
  'Entrega de pulsera y vaso': CupPaper,
  'Restaurantes': ForkKnife,
  'Food trucks': Truck,
  'Callejón del postre': Cake,
  'Mercado': Shop,
  'Free water (agua gratis)': Droplet,
  'Baños': Bath,
  'Cajeros': CardPos,
  'Check in vaso Tecate': Cup,
  'Tienda oficial': ShoppingBag,
  'Lockers': LockKeyhole,
  'Pista de hielo': Snowflake,
  'Puente Maravilla': Roadmap,
  'Área de descanso': Sofa,
  'Servicios médicos': Stethoscope,
  'Zona NFTs': Qr,
  'Acceso 3: VIP y Hospitality': TicketStar,
  'Acceso 5: Fundidora': ArrowDoorIn,
  'Acceso 6: Fundidora': ArrowDoorIn,
  'Acceso CINTERMEX': ArrowDoorIn,
  'Acceso 7: Fundidora': ArrowDoorIn,
  'Zona Ascendente': Rocket,
  'Zona VIP': Crown,
  'Zona Hospitality': Star,
}
